import React, { useState, useEffect } from "react";
import { Col, Modal, Row, Image } from "react-bootstrap";
import icTitle from "../../../assets/images/ic-edit-modal.svg";
import Add from "../../../assets/images/ic-add.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import Back from "../../../assets/images/ic-arrow-back.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { isPermited } from "../../../features/localStorage";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetDocumentModule,
  selectDocumentModule,
} from "../../../features/learning/DocumentSlice";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import Card from "../../../components/card/AdminCard";
import {
  GetInsertMaterial,
  selectInsertMaterial,
} from "../../../features/learning/insertMaterialSlice";
import { Form, InputGroup } from "react-bootstrap";
import Search from "../../../assets/images/search-line.svg";
import FileUpload from "../../../components/textField/FileUpload";
import Feedback from "../../../components/feedbackNote/Feedback";
import { useForm } from "react-hook-form";
import MultiSelectCompany from "../../../components/textField/MultiSelectCompany";
import {
  GetAllCompany,
  selectAllCompany,
} from "../../../features/company/companyListSlice";
import Dropdown from "../../../components/dropdown/Dropdown";
import { useParams } from "react-router-dom";
import {
  GetCategoryList,
  GetCategoryListAsync,
} from "../../../features/learning/CategorySlice";

const title: String = "";
const required = "This field is required";
const pattern = "Please insert valid input";

// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const DocumentModulesDetails = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const { categoryId }: any = params || "";

  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const DocumentModule = useAppSelector(selectDocumentModule);
  const allCompany = useAppSelector(selectAllCompany);

  const [ofset, setOfset] = useState(0);
  const [comapnyList, setCompanyList] = useState<any>();
  const [companyId, setCompanyId] = useState([]);
  const [buId, setBuId] = useState(1);
  const [sectorId, setSectorId] = useState(1);
  const [category, setCategory] = useState("");

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const isAdmin = localStorage.getItem("isAdmin");
  const isAdminList: any = isAdmin;
  const isAdminJson = JSON.parse(isAdminList);

  const categoryList = useAppSelector(GetCategoryList);
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, []);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      // let categoryDropdown: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          name: val?.categoryName,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`,
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  useEffect(() => {
    if (categoryId) {
      setCategory(categoryId);
    }
  }, [categoryId]);

  useEffect(() => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetDocumentModule(data));
    }
    fetchLearningModuleData();
  }, [companyId]);

  var searchParams: any;
  const handleShow = () => {
    setModalShow(true);
    if (isAdminJson === false) {
      // call non sso comapny with id
      const fetchCompany = async () => {
        await dispatch(
          GetAllCompany(
            (searchParams = { type: 2, id: userDetailsJson.companyId })
          )
        );
      };
      fetchCompany();
    } else {
      // call sso +non sso company
      const fetchAllComany = async () => {
        await dispatch(GetAllCompany((searchParams = { type: "", id: 0 })));
      };
      fetchAllComany();
    }
  };

  const [titleFeild, setTitle] = useState("");
  const [file, setFile] = useState("");
  const [description, setDescription] = useState("");
  const [paste, setPaste] = useState("");
  const InsertMaterial = useAppSelector(selectInsertMaterial);

  // Modal Code end
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //event.preventDefault();
    //return false;
    var setBuid = buId.toString();
    var setSectorId = sectorId.toString();
    var setCompnayId = companyId.toString();
    var data = {
      title: titleFeild,
      moduleId: 4,
      description: description,
      mediaType: "Documents",
      materialPath: file,
      externalUrl: paste,
      moduleType: "Learning Modules",
      companyId: setCompnayId,
      status: 0,
      buid: setBuid,
      sectorId: setSectorId,
      materialCategory: category,
    };

    await dispatch(GetInsertMaterial(data));
    var getdata = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    dispatch(GetDocumentModule(getdata));
    handleClose();
  };
  const [searchData, setsearchData] = useState("");
  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };

    await dispatch(GetDocumentModule(data));
  };

  const fetchLearningModuleData = () => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    dispatch(GetDocumentModule(data));
  };

  return (
    <>
      <Feedback pageName="Learning And Awarness" />
      <Row>
        <Col sm={12}>
          <a href="/learning">
            <span style={styles.backstyle}>
              <Image src={Back} />
              Back{" "}
            </span>
          </a>
        </Col>
      </Row>
      <EmptyRow />
      <Row>
        <Col sm={7}>
          <h4>Document</h4>
        </Col>
        <Col sm={1}>
          {isPermited(4, 2) && (
            <a onClick={handleShow}>
              {" "}
              <span style={styles.editstyle}>
                <Image src={Add} /> ADD
              </span>
            </a>
          )}

          <Modal
            show={modalShow}
            onHide={handleClose}
            backdrop="static"
            size="lg"
            keyboard={false}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <ENGModalHeader icon={icTitle} title=" Add New Document " />
              <ENGModalBody
                contents={
                  <>
                    {/* <Row style={styles.divWhite}>
<Col lg={6}>
                      <label htmlFor="sector" >Select Sector</label> */}
                    {/* <Multiselect
                        options={SectorList}
                        onSelect={onSelectSector}
                        onRemove={onRemoveSector}
                        ref={ref}
                        name="teammember"
                        displayValue="name"
                        showCheckbox={true}
                    />    */}
                    {/* <MultiSelectCheck SectorList={SectorList} setSectorId={setSectorId}/>
                      </Col>
                      <Col lg={6}>
                      <label htmlFor="Unit" >Select Business Unit</label> */}
                    {/* <Multiselect
                        options={BusinessUnitList}
                        onSelect={onSelectBu}
                        onRemove={onRemoveBu}
                        ref={ref}
                        name="teammember"
                        displayValue="name"
                        showCheckbox={true}
                    />    */}
                    {/* <MultiSelectCheckBu SectorList={BusinessUnitList} setBuId={setBuId} />
                      </Col>
                    </Row> */}

                    <Row style={styles.divWhite}>
                      <Col sm={12} className="desk">
                        <label htmlFor="Unit">
                          Category <span style={styles.star}> * </span>
                        </label>
                        <Dropdown
                          id="Category"
                          data={dataList}
                          value={category}
                          onchange={setCategory}
                          isRequired
                        />
                      </Col>
                      <EmptyRow />

                      <Col lg={6}>
                        <div className="floating-label-group">
                          <input
                            type="text"
                            id="title"
                            name="title"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setTitle(ev.target.value)}
                            className="textstyle"
                            ref={register({
                              required: true,
                              pattern: /^[a-zA-Z0-9\s]*$/g,
                            })}
                          />
                          <label className="floating-label">
                            Title <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.title &&
                          errors.title.type === "required" &&
                          errorMessage(required)}
                        {errors.title &&
                          errors.title.type === "pattern" &&
                          errorMessage(pattern)}
                      </Col>
                      <Col lg={6}>
                        {/* <div className="floating-label-group">
                          <input
                            type="file"
                            id="File"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setFile(ev.target.value)}
                            className="textstyle"
                          />
                          <label className="floating-label">File <span style={styles.star}> * </span></label>
                        </div> */}
                        <FileUpload
                          setFile={setFile}
                          title="File"
                          fileValue=""
                          fileType="PDF"
                        />
                      </Col>
                    </Row>
                    <Row style={styles.divWhite}>
                      <Col lg={12} className="mt-4">
                        <div className="floating-label-group">
                          <input
                            type="text"
                            name="description"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setDescription(ev.target.value)}
                            className="textstyle"
                            ref={register({
                              required: true,
                              pattern: /^[a-zA-Z0-9\s]*$/g,
                            })}
                            //ref={register({ required: true})}
                          />
                          <label className="floating-label">
                            Description <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.description &&
                          errors.description.type === "required" &&
                          errorMessage(required)}
                        {errors.description &&
                          errors.description.type === "pattern" &&
                          errorMessage(pattern)}
                      </Col>
                      <Col lg={6} className="mt-4">
                        <label htmlFor="Unit">Accessible To</label>
                        {/* <MultiSelectCompany
                          SectorList={allCompany}
                          setCompanyId={setCompanyId}
                        /> */}
                        <MultiSelectCompany
                          optionList={allCompany}
                          setId={setCompanyId}
                          selectedValue={""}
                          valueKey="id"
                          labelKey="company"
                          isAdd={true}
                        />
                      </Col>
                    </Row>
                  </>
                }
              />
              <EmptyRow />
              <EmptyRow />
              <Row style={styles.divGrey}>
                <Col sm={9}></Col>
                <Col sm={3}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={styles.button1}
                  >
                    {" "}
                    CANCEL{" "}
                  </button>
                  <button type="submit" style={styles.button}>
                    {" "}
                    SAVE{" "}
                  </button>
                </Col>
              </Row>
            </form>
          </Modal>
        </Col>

        {/* <Col sm={1}>
          {isPermited(4,3) && 
            <a href="/documentmodulesEditDetails"><span style={styles.editstyle}><Image src={Edit} /> EDIT</span></a>
            }
        </Col> */}
        <Col sm={4}>
          <InputGroup
            className="border bg-white"
            style={{ border: "solid 1px #e4e4e4" }}
          >
            <Image
              style={styles.image1}
              className="d-inline border-0 my-auto mx-2"
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className="border-0 shadow-none ps-0"
              style={styles.text1}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
      </Row>

      <EmptyRow />

      <div style={{ marginBottom: "20px" }}>
        <Card
          type={4}
          title={title}
          data={DocumentModule}
          moduleid={4}
          fetchLearningModuleData={fetchLearningModuleData}
          modal={
            <>
              {/* <LearningModulesModal title="Learning Modules" records={LearingModule}/> */}
              {/* <LearningModulesEdit data={LearingModule}/> */}
            </>
          }
        />
      </div>
    </>
  );
};

const styles: any = {
  selectpoperty: {
    backgroundColor: "white",
    paddingBottom: "0px",
    border: "solid 1px #e4e4e4",
    width: "100%",
    fontFamily: "Saira",
    fontSize: "16px",
    color: "#6d6e71",
    borderRadius: "0px",
  },
  star: { color: "#e31837" },

  divWhite: {
    backgroundColor: "#fffff",
    paddingTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },

  editstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    float: "right",
    marginTop: "10px",
  },

  backstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    marginTop: "10px",
  },

  button: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    color: "#fff",
    float: "right",
  },
  button1: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border: "1px solid #e31837",
    letterSpacing: "normal",
    color: "#e31837",
  },
  divGrey: {
    backgroundColor: "rgb(250, 249, 249)",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "20px",
    borderTop: "1px solid #eee;",
  },
  add: {
    padding: "0px",
    fontWeight: "600",
    fontSize: "12px",
    color: "#e31837",
    fontFamily: "saira",
    float: "right",
  },

  del: {
    padding: "0px",
    fontWeight: "600",
    fontSize: "12px",
    color: "#e31837",
    fontFamily: "saira",
  },

  tabHeading: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#f4f4f4",
  },
  colBorder: {
    border: "solid 1px #e4e4e4",
  },
  colBorder1: {
    border: "solid 1px #e4e4e4",
    height: "100%",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "left",
  },
  heading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  data: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
  },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
  },
};

export default DocumentModulesDetails;
